export default __webpack_public_path__ + "static/media/crossIconOrange.32e462c2.svg";